import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

//datepicker
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";

//ckeditor
import {  SwalError } from "../../../../utils/constants";
//utils
import { FileUploader } from "../../../../components/FileUploader/FileUploader";
import {
  create,
  getAll,
  getById,
  saveFile,
  update,
} from "../../../../utils/requests/dynamicReq";
import { paths } from "../../../../utils/paths";


//middleware
import moment from "moment";
import Swal from "sweetalert2";
import Axios from "axios";
import { validate } from "./validations";
import { ROUTES } from "../../../../utils/routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDelete } from "../../../../utils/hooks/useDelete";
import { useSelector } from "react-redux";
import { ArchiveUploader } from "../../../../components/FileUploader/ArchiveUploader";

registerLocale("es", es);

export const ManageConvocatoria = () => {
  let { isAdmin, userRoleId } = useSelector(({ user }) => user);

  const { CONVOCATORIAS, FINANCIADORAS } = paths;
  const { id } = useParams();
  const history = useHistory();
  const { deleteIt } = useDelete();
  const [isCreate, setIsCreate] = useState(false);

  const [nombreSubconvocatoria, setNombreSubconvocatoria] = useState("");
  const [anyo, setAnyo] = useState("");
  const [codigo, setCodigo] = useState("");
  const [contacto, setContacto] = useState("");
  const [info, setInfo] = useState("");
  const [fecha, setFecha] = useState(new Date());
  const [tipoConvocatoria, setTipoConvocatoria] = useState("");
  const [financiadora, setFinanciadora] = useState([])
  const [chosenFinanciadoraId, setChosenFinanciadoraId] = useState("");
  const [logoFinanciacion, setLogoFinanciacion] = useState();
  const [adjunto, setAdjunto] = useState()  

  const [message, setMessage] = useState("");
  const [allowedEdit, setAllowedEdit] = useState(false);

  const isMounted = useRef(false);
  const source = Axios.CancelToken.source();

  useEffect(() => {
    isMounted.current = true;
    const { pathname } = history.location;
    pathname.includes("crear") ? loadDefaultData() : loadEditData();
    return () => {
      isMounted.current = false;
      source.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadDefaultData = async () => {
    try {     
      let financiadoras = await getAll(FINANCIADORAS, source);
      if (isMounted.current) {
        setIsCreate(true);
        setAllowedEdit(true);      
        setFinanciadora(financiadoras);        
      }
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  }; 

  const loadEditData = async () => {
    try {
      let response = await getById(CONVOCATORIAS, id, source);	
      isMounted.current && buildObjToLoad(response);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const buildObjToLoad = async (p) => {   
    let allFinanciadoras = await getAll(FINANCIADORAS, source)
    const startDateWithOffset = new Date(p.fecha);
    const startDateNoOffset = new Date(
      startDateWithOffset.getTime() -
        startDateWithOffset.getTimezoneOffset() * -60000
    );
    setTipoConvocatoria(p.tipoConvocatoria);
    setNombreSubconvocatoria(p.nombreSubconvocatoria);   
    setCodigo(p.codigo);
    setContacto(p.contacto);
    setInfo(p.info);
    setAnyo(p.anyo);    
    setFecha(startDateNoOffset)    
    setLogoFinanciacion(p.logoFinanciacion);
    setAdjunto(p.adjunto)    
    setChosenFinanciadoraId(p.financiadora?.id)    
    setFinanciadora(allFinanciadoras)  
  };


  const handleSubmit = () => {
    const convocatoria = build();
//     const notValid = validate(convocatoriaect);
//     if (notValid) {
//       setMessage(notValid);
//       setTimeout(() => setMessage(""), 4000);
//       return;
//     }
    let question = isCreate ? "crear una" : "editar esta";
    Swal.fire({
      icon: "question",
      text: `¿Quieres ${question} convocatoria?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(
      ({ isConfirmed }) => isConfirmed && handleConfirmation(convocatoria)
    );
  };

  const handleConfirmation = (convocatoria) => {
    let createOrUpdate = isCreate
      ? create(CONVOCATORIAS, convocatoria, source)
      : update(CONVOCATORIAS, id, convocatoria, source);
    createOrUpdate
      .then(async ({ id: convocatoriaId }) => {
        // const investigatorProjects = buildInvestigatorProject(
        //   chosenParticipants,
        //   chosenIps,
        //   projectId
        // );
     
        let createOrUpdateText = isCreate ? "creada" : "editada";

        Swal.fire({
          icon: "success",
          text: `Convocatoria ${createOrUpdateText} correctamente.`,
        });
        if (typeof logoFinanciacion !== "string") {
          const formData = new FormData();
          formData.append("image", logoFinanciacion);
          await saveFile(
            CONVOCATORIAS,
            convocatoriaId,
            "logo-financiacion",
            formData,
            source
          );
        }
        if (typeof adjunto !== "string") {
          const formData = new FormData();
          formData.append("document", adjunto);
          await saveFile(CONVOCATORIAS, convocatoriaId, "adjunto", formData, source);
        }
        history.push(`${ROUTES.Convocatorias.all}/${convocatoriaId}`);
        isMounted.current && setIsCreate(false);
      })
      .catch(() => Swal.fire({ icon: "error", text: SwalError }));
  };

  const build = () => {
    const convocatoria = {
      nombreSubconvocatoria,
      tipoConvocatoria,      
      fecha: moment(fecha).format("YYYY-MM-DD"),   
      codigo,     
      anyo,
      contacto,
      info,   
      financiadoraId: +chosenFinanciadoraId
    };  
    return convocatoria;
  };

  const editDeleteButtons = () => {
    if (isCreate) {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear Convocatoria
        </button>
      );
    }
    //if is update && logged user included as IP
    return (
      <>
        <button className="baseBtn" onClick={handleSubmit}>
          Guardar cambios
        </button>
        <button
          className="smallBtn btn-danger ml-1"
          onClick={() =>
            deleteIt(CONVOCATORIAS, id, ROUTES.Convocatorias.all, source)
          }
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </>
    );
  };
  return (
    <div className="centerPage">
      {(isAdmin || userRoleId === 3 || userRoleId === 2) && (
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col d-flex justify-content-between">
              <div>
                <h3>Convocatoria </h3>
              </div>
              <div>{editDeleteButtons()}</div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 text-center text-danger">
              <span>{message}</span>
            </div>
          </div>
          <div className=" form-row mt-2 ">
            <div className="col-6 d-flex justify-content-center">
              <FileUploader
                handleFile={setLogoFinanciacion}
                image={logoFinanciacion}
              />
            </div>
            <div className="col-6 d-flex justify-content-center">
              <ArchiveUploader handleFile={setAdjunto} archive={adjunto} />
            </div>
            <div className="col-6  d-flex flex-column  ">
              <small>Nombre</small>
              <input
                type="text"
                className="form-control"
                placeholder="*Nombre español"
                value={nombreSubconvocatoria}
                onChange={({ target: { value } }) =>
                  setNombreSubconvocatoria(value)
                }
                // disabled={!allowedEdit}
              />
            </div>
          </div>

          <div className="form-row mt-2">
            <div className="col">
              <span>Fecha de convocatoria</span>
              <DatePicker
                className="form-control input"
                placeholderText="*Fecha de inicio"
                selected={fecha}
                onChange={(date) => setFecha(date)}
                dateFormat="dd MMMM, yyyy"
                isClearable={allowedEdit}
                locale="es"
                // disabled={!allowedEdit}
              />
            </div>

            <div className="col">
              <small>Tipo Convocatoria</small>
              <select
                className="form-control input"
                value={tipoConvocatoria}
                onChange={({ target: { value } }) => {
                  setTipoConvocatoria(value);
                }}
              >
                <option value="">Seleccione una opción</option>
                <option value="Local">Local</option>
                <option value="Regional">Regional</option>
                <option value="Nacional">Nacional</option>
                <option value="Europea">Europea</option>
                <option value="Internacional">Internacional</option>
                <option value="Organismos_internacionales">
                  Organismos internacionales
                </option>
                <option value="Fundaciones_privadas_o_empresas">
                  Fundaciones privadas o empresas
                </option>
              </select>
            </div>
          </div>
          <div className="form-row mt-4">
            <div className="col">
              <span>Año</span>
              <input
                type="number"
                className="form-control"
                placeholder="Año"
                value={anyo}
                onChange={({ target: { value } }) => setAnyo(value)}
                // disabled={!allowedEdit}
              />
            </div>

            <div className="col">
              <span>Contacto Convocatoria</span>
              <input
                type="text"
                className="form-control"
                placeholder="Contacto Conovocatoria"
                value={contacto}
                onChange={({ target: { value } }) => setContacto(value)}
                // disabled={!allowedEdit}
              />
            </div>
            <div className="col">
              <span>Información</span>
              <input
                type="text"
                className="form-control"
                placeholder="Información"
                value={info}
                onChange={({ target: { value } }) => setInfo(value)}
                // disabled={!allowedEdit}
              />
            </div>
            <div className="col">
              <span>Código</span>
              <input
                type="text"
                className="form-control"
                placeholder="Código"
                value={codigo}
                onChange={({ target: { value } }) => setCodigo(value)}
                //disabled={!allowedEdit}
              />
            </div>
          </div>

          <div>
            <div className="form-row mt-2">

            <div className="col-6 d-flex flex-column">
              <small>Seleccionar Entidad coordinadora/financiadora*</small>
              <select
                className="form-control input"
                value={chosenFinanciadoraId}
                onChange={({ target: { value } }) => {
                  setChosenFinanciadoraId(value);
                }}
                >
                <option>Entidad financiadora</option>
                {financiadora?.map(({ id, nombre }) => (
                  <option key={id} value={id}>
                    {nombre}
                  </option>
                ))}
              </select>
                </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
